import * as React from "react";
import { scrollToElemById } from './utils/Scroller';
import bcbcLogo from "../assets/bcbcLogo.jpg";

class Footer extends React.Component {
  public render() {
    return (
      <section className="my-4 text-center" id="theFooter">
        <a onClick={() => scrollToElemById('header')} className="back-to-top my-4">Back to top</a>
        <div className="bcbc-logo my-16 mx-auto">
          <img src={bcbcLogo} alt="Better Councils Better Communities Logo" />
        </div>
        <div className="text-center text-small mt-4 mb-8 copyright">
          <p><a href="mailto:ask@lgaq.asn.au?Subject=My Council Story">ask@lgaq.asn.au</a> | Copyright &copy; 2019</p>
        </div>
      </section>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.tsx